import React from 'react';
import { PostpaidPlanComparerField } from '@sparknz/journeys-common';

import { useProductDetails } from 'journey/productDetails/provider';

const PostpaidChangePlanComparerField = () => {
  const {
    ifpEligibility: {
      selectedLineNumber,
      eligibility: { eligibleLines, ineligibleLines },
      selectedPlanTitle,
    },
  } = useProductDetails();

  const lines = [...eligibleLines, ...ineligibleLines];
  const selectedLineNumberData = lines.filter(
    (item) => item.lineNumber === selectedLineNumber,
  );
  return (
    <PostpaidPlanComparerField
      journeyId="myspark/changePlan"
      currentPlanOfferId={selectedLineNumberData[0]?.offerId}
      currentPlanTitle={selectedLineNumberData[0]?.offerName}
      newPlanTitle={selectedPlanTitle}
    />
  );
};

export default PostpaidChangePlanComparerField;
